// extracted by mini-css-extract-plugin
export var articleTagLink = "article-tag-link-module--article-tag-link--Pb5ca";
export var isSelected = "article-tag-link-module--is-selected--kSh3t";